export namespace SettingLayoutComponentId {
  export const DefaultLogin = 1n;
  export const MinimalLogin = 2n;
  export const GameCardV1 = 3n;
  export const GameCardV2 = 4n;
  export const GameCardV3 = 5n;
  export const ToastyV1 = 6n;
  export const ToastyV2 = 7n;
  export const NotificationsV1 = 8n;
  export const NotificationsV2 = 9n;
  export const BetAmountInputV1 = 10n;
  export const BetAmountInputV2 = 11n;
  export const BetAmountInputV3 = 12n;
  export const BetAmountInputV4 = 13n;
  export const LoginV3 = 14n;
  export const LayoutV1 = 15n;
  export const LayoutV2 = 16n;
  export const TabsV1 = 17n;
  export const TabsV2 = 18n;
  export const TabsV3 = 19n;
  export const ProfileRankCardV1 = 20n;
  export const ProfileRankCardV2 = 21n;
  export const UserProfileChipV1 = 22n;
  export const UserProfileChipV2 = 23n;
  export const UserProfileChipV3 = 24n;
  export const UserProfileChipV4 = 25n;
  export const TournamentCardV1 = 26n;
  export const TournamentCardV2 = 27n;
  export const TournamentCardV3 = 28n;
  export const VipClubCardV1 = 29n;
  export const VipClubCardV2 = 30n;
  export const MainBannerV1 = 31n;
  export const MainBannerV2 = 32n;
  export const LayoutV3 = 33n;
  export const RewardCardV1 = 34n;
  export const RewardCardV2 = 35n;
  export const ToastyV3 = 36n;
  export const RewardIconV1 = 37n;
  export const RewardIconV2 = 38n;
  export const GameCountdownV1 = 39n;
  export const GameCountdownV2 = 40n;
  export const GameVictoryBannerV1 = 41n;
  export const GameVictoryBannerV2 = 42n;
  export const VipClubOverviewV1 = 43n;
  export const VipClubOverviewV2 = 44n;
  //from here are the v2 components
  export const VipClubModalHeaderV1 = 45n;
  export const VipClubModalHeaderV2 = 46n;
  export const VipPerkCardV1 = 47n;
  export const VipPerkCardV2 = 48n;
  export const VipPerksV1 = 49n;
  export const VipPerksV2 = 50n;
  export const VipPrioritySupportV1 = 51n;
  export const AffiliatesOffilineHeaderV1 = 52n;
  export const AffiliatesOffilineHeaderV2 = 53n;
  export const AffiliatesCardV1 = 54n;
  export const AffiliatesCardV2 = 55n;
  export const BonusHeroV1 = 56n;
  export const BonusHeroV2 = 57n;
  export const RewardCardV3 = 58n;
  export const ModalV1 = 59n;
  export const ModalV2 = 60n;
  export const GameCardV4 = 61n;
  export const HomeHeroV1 = 62n;
  export const HomeHeroV2 = 63n;
  export const RewardIconV3 = 64n;
  export const RankProgressV1 = 65n;
  export const RankProgressV2 = 66n;
  export const ProfileRankCardV3 = 67n;
  export const ProfileRankCardV4 = 68n;
  export const GameCardV5 = 69n;
  export const AffiliatesPanelHeroV1 = 70n;
  export const AffiliatesPanelHeroV2 = 71n;
  export const StoriesV1 = 72n;
  export const StoriesV2 = 73n;
  export const CreateReferralVoucherModalV1 = 74n;
  export const CreateReferralVoucherModalV2 = 75n;
  export const ReferralVoucherFormV1 = 76n;
  export const ReferralVoucherFormV2 = 77n;
  export const WithdrawReferralComissionsModalV1 = 78n;
  export const WithdrawReferralComissionsModalV2 = 79n;
  export const WithdrawReferralComissionsHeroV1 = 80n;
  export const WithdrawReferralComissionsHeroV2 = 81n;
  export const BalanceButtonV1 = 82n;
  export const BalanceButtonV2 = 83n;
  export const NavbarV1 = 84n;
  export const NavbarV2 = 85n;
  export const UserProfileV1 = 86n;
  export const UserProfileV2 = 87n;
  export const SidebarV1 = 88n;
  export const SidebarV2 = 89n;
  export const AccountsV1 = 90n;
  export const AccountsV2 = 91n;
  export const RollPointGameV1 = 92n;
  export const RollPointGameV2 = 92n;
}

export type SettingLayoutComponentIdType =
  (typeof SettingLayoutComponentId)[keyof typeof SettingLayoutComponentId];
